module.exports = __webpack_public_path__ + "img/综合业务管理系统.c604df11.png";